module.exports = __webpack_public_path__ + "img/configure-benefits-hover.5904602c.svg";